<script>
export default {
  name: 'WardList',
  props: {
    wards: {
      type: Array,
      required: true,
    },
  },
  computed: {
    timesIcon() {
      return new URL('../../../assets/images/icons/times.svg', import.meta.url)
        .href;
    },
  },
};
</script>

<template>
  <div class="ward-list">
    <a-card v-for="(ward, index) in wards" :key="index" class="ward">
      <div class="ward-content">
        <div class="ward-info">
          <a-avatar :name="ward.name" class="secondary"></a-avatar>
          <div class="text-left ml-2">
            <a-text>{{ ward.name }}</a-text>
          </div>
        </div>

        <img
          class="clickable"
          :src="timesIcon"
          @click="$emit('remove-ward', index)"
        />
      </div>
    </a-card>
  </div>
</template>

<style scoped lang="scss">
.ward-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}
.ward {
  margin: 0;
  display: flex;
  padding: 16px;
  border-radius: 8px !important;
  border: 1px solid #d3d3d3;
  .ward-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .ward-info {
      display: flex;
      align-items: center;
    }
  }
}
</style>
